import type { Pip } from '../../types/Pip';

export const pipBaseFeatureConfig: Pip = {
    shouldShowBackNavigationOnOrderSummary: true,
    shouldShowFullCatalogueLink: true,
    tilePriceHistoryExchangeCode: '',
    hideTitleDetailPage: false,
};
